const routes = [
  {
    path: '/member',
    name: 'Member',
    component: () => import(/* webpackChunkName: "member" */ '@/views/member/MemberMain'),
    children: [
      {
        path: 'list',
        alias: '',
        name: 'MemberList',
        component: () => import(/* webpackChunkName: "member" */ '@/views/member/MemberList'),
        prop: true,
        meta: {
          step: ['계정 관리', '계정 관리 리스트']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'MemberView',
        component: () => import(/* webpackChunkName: "member" */ '@/views/member/MemberView'),
        prop: true,
        meta: {
          step: ['계정 관리', '계정 관리 세부']
        }
      },
      {
        path: 'write',
        name: 'MemberWrite',
        component: () => import(/* webpackChunkName: "member" */ '@/views/member/MemberView'),
        prop: true,
        meta: {
          step: ['계정 관리', '계정 관리 등록']
        }
      }
    ]
  }
]

export default routes
